var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[(_vm.text)?_c('div',{staticClass:"preloader-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }